import { Button, Grid, TextField } from "@material-ui/core"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {addCantiadPasajerosAction, addItemsAction} from "./../../../../../ducks/cambioPaqueteDuck"
import {ToastMessage} from "./../../../../../global/ToastMessage"
const FieldCatidadPasajero = () => {
    const { cantidadPasajeros, listaItems, clavePaquete } = useSelector(store => store.cambiosPaquete)
    const { cliente } = useSelector(store => store.cambios)
    const noPax = cliente.paquete?.Numero_Personas ?? 0
    const [editar, setEditar] = useState(false)
    const dispatch = useDispatch()
    
    useEffect(() => {
        dispatch(addCantiadPasajerosAction({cantidadPasajeros: noPax }))
    },[dispatch, noPax])

    const handleGuardar = () => {
        hangdleClickEditar()
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    const hangdleClickCancelar = () => {
        setEditar(!editar)
    }
    const handleChange = (event) => {
        const newCantidadPasajeros = event.target.value
        
        if (Number(newCantidadPasajeros) <= 0) {
            ToastMessage.fire({
                icon: "info",
                title: "La cantidad de pasajeros debe ser mayor o igaul a 1",
            })
            return null
        }

        if (listaItems.find(item => item.name === "Sencilla")) {
            ToastMessage.fire({
                icon: "info",
                title: "No se puede agregar mas pasajeros, plaza Sencilla",
            })
            dispatch(addCantiadPasajerosAction({cantidadPasajeros: 1 }))
            return null
        }

        if (listaItems.find(item => item.name === "Compartida")) {
            ToastMessage.fire({
                icon: "info",
                title: "No se puede agregar mas pasajeros, plaza Compartida",
            })
            dispatch(addCantiadPasajerosAction({cantidadPasajeros: 1 }))
            return null
        }

        dispatch(addCantiadPasajerosAction({cantidadPasajeros: newCantidadPasajeros }))
        let arrayItems = [...listaItems]
        arrayItems = arrayItems.map(item => {
            if (item.type === "PAQUETE")
                return {...item, quantity: Number(newCantidadPasajeros) }
            if (item.type === "SALIDA" || item.type === "EXTRA")
                return {...item, quantity: Number(newCantidadPasajeros) }
            return item
        })
        dispatch(addItemsAction({listaItem: arrayItems}))
    }
    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <TextField
                            disabled={!editar || clavePaquete === "0"}
                            value={cantidadPasajeros}
                            style={{ width: "100%" }}
                            id={`outlined-number-conter`}
                            label="No. Pasajeros total"
                            name="noPasajeros"
                            onChange={handleChange}
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                inputProps: { min: 0, max: 10 }
                            }}
                            variant="outlined"
                        />
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={hangdleClickEditar}
                                disabled={clavePaquete === "0"}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    disabled={cantidadPasajeros === 0}
                                    onClick={handleGuardar}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    onClick={hangdleClickCancelar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
export default FieldCatidadPasajero